import React, { useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"
import styles from "./sendMessage.module.css"
import { MdOutlineEmojiEmotions, MdOutlineMicNone, MdOutlinePause } from "react-icons/md"
import Message from "../../../Message"
import FormGroup from "../../../Form/FormGroup"
import Select from "../../../Form/Select"
import FormGroupInline from "../../../Form/FormGroupInline"
import Button from "../../../Form/Button"
import Emojis from "../../../Chat/Emojis"
import { insertTextAtCursor } from "../../../Chat/RichTextarea"
import Textarea from "../../../Form/Textarea"
import InputFile from "../../../Form/InputFile"
import Input from "../../../Form/Input"
import ModalLocation from "../../Chat/ModalLocation"

const optionsType = [
    { id: "text", value: "Texto" },
    { id: "image", value: "Imagem" },
    { id: "video", value: "Vídeo" },
    { id: "document", value: "Documento" },
    { id: "audio", value: "Áudio" },
    { id: "location", value: "Localização" },
    { id: "contact", value: "Contato" },
]

const validOptionsWithText = [
    "text",
    "image",
    "video",
    "document",
]

const validOptionsWithFile = [
    "image",
    "video",
    "document",
    "audio",
]

const SendMessage = ({ message = {}, onChange = () => { } }) => {
    const [acceptFiles, setAcceptFiles] = useState("")
    const [, setValidMessage] = useState(false)
    const [showEmotions, setShowEmotions] = useState(false)
    const [showModalLocation, setShowModalLocation] = useState(false)

    const [isRecording, setIsRecording] = useState(false)
    const [isPaused, setIsPaused] = useState(false)
    const [recordingTime, setRecordingTime] = useState(0)
    const [audioChunks, setAudioChunks] = useState([])

    const textareaRef = useRef(null)
    const mediaRecorderRef = useRef(null)
    const intervalRef = useRef(null)

    useEffect(() => {
        let isValid = false
        if (message?.name && message?.type) {
            switch (message.type) {
                case "text":
                    isValid = !!message?.content?.text
                    break;
                case "image":
                    isValid = !!message?.content?.url && (message?.content?.file?.length > 0 || !!message?.content?.keyFileS3)
                    break;
                case "video":
                    isValid = !!message?.content?.url && (message?.content?.file?.length > 0 || !!message?.content?.keyFileS3)
                    break;
                case "document":
                    isValid = !!message?.content?.url && (message?.content?.file?.length > 0 || !!message?.content?.keyFileS3)
                    break;
                case "audio":
                    isValid = !!message?.content?.url && !!message?.content?.audio
                    break;
                case "location":
                    isValid = !!message?.content?.latitude && !!message?.content?.longitude
                    break;
                case "contact":
                    isValid = !!message?.content?.contacts?.[0]?.details?.name && !!message?.content?.contacts?.[0]?.details?.phone
                    break;
                default:
                    break;
            }
        }
        setValidMessage(isValid)
    }, [message])

    useEffect(() => {
        handleChangeContent("file", [])
        if (message?.type === "image") {
            setAcceptFiles("image/*")
        } else if (message?.type === "video") {
            setAcceptFiles("video/*")
        } else if (message?.type === "audio") {
            setAcceptFiles("audio/*")
        } else {
            setAcceptFiles("*")
        }
        if (message?.type !== "audio") {
            handleDeleteRecording()
        }
    }, [message?.type])

    useEffect(() => {
        if (isPaused && audioChunks?.length > 0) {
            const audioBlob = new Blob(audioChunks, { type: 'audio/webm' })
            handleChangeContent('file')
            handleChangeContent('audio', audioBlob)
        }
    }, [isPaused, audioChunks])

    const handleChangeContent = (name, value) => {
        let additionalValue = {}
        if (name === "file") {
            const file = value?.[0]
            if (file) {
                if ((message?.type === "image" && !file?.type?.startsWith('image/')) || (message?.type === "video" && !file?.type?.startsWith('video/'))) {
                    return toast.error("O arquivo selecionado é inválido!")
                }
                if (message?.type === "audio") {
                    handleChangeContent('audio', file)
                    handleDeleteRecording()
                } else {
                    additionalValue.url = URL.createObjectURL(file)
                    additionalValue.name = file?.name
                    additionalValue.mimetype = file?.type
                    additionalValue.size = file?.size
                }
            } else {
                if (message?.content?.file?.length > 0) {
                    additionalValue.url = undefined
                    additionalValue.urlThumb = undefined
                }
                additionalValue.name = undefined
                additionalValue.mimetype = undefined
                additionalValue.size = undefined
            }
        }
        if (name === "audio") {
            additionalValue.url = value ? URL.createObjectURL(value) : undefined
        }
        if (message?.type !== "audio") {
            additionalValue.audio = undefined
        }
        if (message?.type !== "contact") {
            additionalValue.contacts = undefined
        }
        if (message?.type !== "location") {
            additionalValue.latitude = undefined
            additionalValue.longitude = undefined
            additionalValue.address = undefined
        }
        if (!validOptionsWithText.includes(message?.type)) {
            additionalValue.text = undefined
        }
        const content = { ...message?.content, ...additionalValue, [name]: value }
        onChange("content", content)
    }

    const handleChangeContact = (name, value) => {
        const contact = { ...message?.content?.contacts?.[0], details: { ...message?.content?.contacts?.[0]?.details, [name]: value } }
        if (name === "name") {
            contact.displayName = value
        }
        handleChangeContent("contacts", [contact])
    }

    const handleToogleEmotions = () => {
        setShowEmotions(previousValue => !previousValue)
    }

    const addEmoji = (emoji, textarea, value = "", cbFunction = () => { }) => {
        insertTextAtCursor(textarea, value, emoji, cbFunction)
    }

    const handleStartRecording = async () => {
        try {
            setIsRecording(true)
            setIsPaused(false)
            setRecordingTime(0)
            setAudioChunks([])
            clearInterval(intervalRef.current)
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
            const mediaRecorder = new MediaRecorder(stream)
            mediaRecorderRef.current = mediaRecorder

            mediaRecorder.ondataavailable = event => {
                if (event.data.size > 0) {
                    setAudioChunks(prev => [...prev, event.data])
                }
            }

            mediaRecorder.start()

            intervalRef.current = setInterval(() => {
                setRecordingTime(prevTime => prevTime + 1)
            }, 1000)
        } catch (err) {
            const message = getErrorMessage(err)
            toast.error(message)
        }
    }

    const getErrorMessage = (err) => {
        if (!navigator.mediaDevices) {
            return 'Seu navegador não suporta gravação de áudio.'
        }

        if (!window.MediaRecorder) {
            return 'Gravação de áudio não é suportada neste dispositivo.'
        }

        if (err.name === 'NotAllowedError') {
            return 'Permissão de microfone negada. Verifique as configurações.'
        }

        return 'Não foi possível iniciar a gravação. Tente novamente.'
    }

    const handlePauseRecording = () => {
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop()
            mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop())
            clearInterval(intervalRef.current)
            setIsPaused(true)
            setIsRecording(false)
        }
    }

    const handleDeleteRecording = () => {
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop()
            mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop())
            clearInterval(intervalRef.current)
        }
        setIsRecording(false)
        setIsPaused(false)
        setRecordingTime(0)
        setAudioChunks([])
    }

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60)
        const seconds = time % 60
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
    }

    const handleOpenModalLocation = (e) => {
        e?.preventDefault()
        setShowModalLocation(true)
    }

    const handleCloseModalLocation = (e) => {
        e?.preventDefault()
        setShowModalLocation(false)
    }

    const handlePreviewLocation = (location) => {
        const latitude = location?.latitude
        const longitude = location?.longitude
        const address = location?.address
        handleChangeContent("latitude", latitude)
        handleChangeContent("longitude", longitude)
        handleChangeContent("address", address)
        handleCloseModalLocation()
    }

    return (
        <div className={styles.container}>
            <div className={styles.groupMessage}>
                {message?.type &&
                    <Message
                        message={message}
                        showActions={false}
                    />
                }
            </div>
            <div className={styles.content}>
                <FormGroup labelText="Tipo">
                    <Select placeholder="Selecione uma opção" name="Tipo" onChange={(value) => onChange("type", value)} selected={message?.type || ""} options={optionsType} />
                </FormGroup>
                {message?.type && validOptionsWithText.includes(message.type) &&
                    <FormGroup labelText="Texto">
                        <FormGroupInline>
                            <div className={styles.groupEmotions} onClick={handleToogleEmotions}>
                                <Button variant="primary" className="action"><MdOutlineEmojiEmotions /></Button>
                                {showEmotions &&
                                    <>
                                        <div className={styles.emotions}>
                                            <Emojis
                                                onClick={(emoji) => addEmoji(emoji, textareaRef.current, message?.content?.text || "", (newText) => handleChangeContent("text", newText))}
                                            />
                                        </div>
                                        <div className={styles.background}></div>
                                    </>
                                }
                            </div>
                            <Textarea
                                elementRef={textareaRef}
                                placeholder="Texto"
                                onChange={(e) => handleChangeContent("text", e.target.value)}
                                value={message?.content?.text || ""}
                            />
                        </FormGroupInline>
                    </FormGroup>
                }
                {message?.type === "audio" &&
                    <FormGroup labelText="Gravar Áudio">
                        <FormGroupInline style={{ justifyContent: "flex-start" }}>
                            {isRecording ?
                                <Button variant="secondary" className="action" onClick={handlePauseRecording}><MdOutlinePause /></Button>
                                :
                                <Button variant="secondary" className="action" onClick={handleStartRecording}><MdOutlineMicNone /></Button>
                            }
                            <div className={styles.recordingTime}>
                                <div className={styles.iconRecording}></div>
                                <span>{formatTime(recordingTime)}</span>
                            </div>
                        </FormGroupInline>
                    </FormGroup>
                }
                {message?.type && validOptionsWithFile.includes(message.type) &&
                    <FormGroup labelText="Arquivo">
                        <InputFile multiple={false} onChange={(value) => handleChangeContent("file", value)} value={message?.content?.file || []} accept={acceptFiles} />
                    </FormGroup>
                }
                {message?.type === "location" &&
                    <>
                        {(message?.content?.latitude && message?.content?.longitude) &&
                            <FormGroup labelText="Descrição">
                                <Input type="text" placeholder="Descrição" onChange={(e) => handleChangeContent("address", e.target.value)} value={message?.content?.address || ""} />
                            </FormGroup>
                        }
                        <FormGroup>
                            <Button variant='accent' onClick={handleOpenModalLocation}>Obter Localização</Button>
                        </FormGroup>
                    </>
                }
                {message?.type === "contact" &&
                    <>
                        <FormGroup labelText="Nome do Contato">
                            <Input type="text" placeholder="Nome do Contato" onChange={(e) => handleChangeContact("name", e.target.value)} value={message?.content?.contacts?.[0]?.details?.name || ""} />
                        </FormGroup>
                        <FormGroup labelText="Celular do Contato">
                            <Input type="phone" placeholder="Celular do Contato" onChange={(e) => handleChangeContact("phone", e.target.value)} value={message?.content?.contacts?.[0]?.details?.phone || ""} />
                        </FormGroup>
                    </>
                }
            </div>
            {showModalLocation &&
                <ModalLocation
                    latitude={message?.content?.latitude}
                    longitude={message?.content?.longitude}
                    onlyPreview={true}
                    onPreview={handlePreviewLocation}
                    closeModal={handleCloseModalLocation}
                />
            }
        </div>
    )
}

export default SendMessage
